var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success"},[_c('img',{staticClass:"success-img",attrs:{"src":"https://c.cdn.quyixian.com/front/2023/con.png","alt":""}}),_c('div',{staticClass:"success-title"},[_vm._v("信息提交成功")]),_c('p',{staticClass:"success-content"},[_vm._v("您的中奖信息已提交成功，请耐心等待")]),_c('p',{staticClass:"success-content"},[_vm._v("感谢支持，祝学业进步！")])])
}]

export { render, staticRenderFns }